import React from "react";
// core components
import { Col, Row } from 'reactstrap';

import uniqBy from 'lodash/uniqBy';

import { IoMdCheckmark, IoMdRemove, IoIosSearch } from 'react-icons/io'
import { FaFileUpload, FaFolderPlus } from 'react-icons/fa';

import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { bindActionCreators }  from 'redux';
import queryString from 'query-string';

import RightSidebar from '../RightSidebar';

import commonStyle from 'commonStyle';

import { formatter, url } from 'utils';

import Button from 'components/Button';
import PathBreadcrumbs from 'components/PathBreadcrumbs';
import Spacer from 'components/Spacer';
import TruncateLine from 'components/TruncateLine';
import TableRow from 'components/TableRow';

import { deleteObjects } from 'api/actions';

import { withoutAuth, withSearch } from 'HOC';

import {
  GET_OBJECTS,
  GET_OBJECTS_SUCCESS,
  GET_OBJECTS_FAILURE,
  DELETE_OBJECTS,
  DELETE_OBJECTS_SUCCESS,
  DELETE_OBJECTS_FAILURE
} from '../../../constants/ActionTypes'

import './index.css'

let bottomScroll = -1;

class MainView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      hoveringOver: null,
      page: 0,
      selections: [],
      loading: false,
    };
  }

  async componentWillReceiveProps(nextProps) {
    const newState = {};

    switch (nextProps.type) {
      case DELETE_OBJECTS:
        await this.startLoading();
        break;

      case DELETE_OBJECTS_SUCCESS:
        await this.stopLoading();

        const { data } = this.state;

        const { deletedIds } = nextProps;

        this.setState({
          data: data.filter(object => !deletedIds.includes(object.id)),
          selections: []
        });
        break;

      case DELETE_OBJECTS_FAILURE:
        await this.stopLoading();
        break;
    }

    if (nextProps.refresh) {
      this.refresh();
    }
  }

  componentWillMount() {
    bottomScroll = -1;

    this.setState({
      data: [],
      hoveringOver: null,
      selections: [],
      loading: false,
    });
  }

  fetchMore = () => {
    const { fetchMore } = this.props;

    if (fetchMore) fetchMore();
  };

  refresh = () => {
    this.setState({
      selections: []
    });
  }

  trackScrolling = (e) => {
    // Do this to prevent the component from rendering each time the user scrolls up.
    if (e.target.scrollTop > bottomScroll) {
      const bottom = e.target.scrollHeight - e.target.scrollTop >= (e.target.clientHeight * 0.6);

      bottomScroll = e.target.scrollTop;
      if (bottom) {
        this.fetchMore();
      }
    }
  };

  updateSelections = updatedSelections => new Promise(resolve => {
    this.setState({
      selections: updatedSelections
    }, resolve)
  });

  deselectAll = async () => {
    await this.updateSelections([]);
  };

  startLoading = () => new Promise(resolve => this.setState({ loading: true }, resolve));

  stopLoading = () => new Promise(resolve => this.setState({ loading: false }, resolve));

  onDelete = () => {
    this.props.deleteObjects({ ids: this.state.selections });
  }

  onDownload = async () => {
    // await this.props.getObjectDownload({ id: this.state.selections[0] });

    // const preview = this.props.preview;

    // if (preview) {
    //   const { downloadUrl, item } = preview;

    //   url.downloadUrl(item, downloadUrl);
    // }
  }


  renderNoData = () => {
    if (this.props.loading) {
      return null;
    } else {
      return (
        <div className={'empty-bucket'}>
          <h3>{this.props.emptyTitle}</h3>
          <p>{this.props.emptyDescription}</p>
        </div>
      )
    }
  }

  renderTable = ({ data, oneSelected, multipleSelected, allSelected }) => (
    <table>
      <thead>
        <tr
          onMouseOver={() => {
            this.setState({
              hoveringOver: 'rowHead'
            })
          }}
          onMouseLeave={() => {
            this.setState({
              hoveringOver: null
            })
          }}
        >
          <td >
            {(oneSelected || multipleSelected) &&
              <div
                className={'checkbox'}
                onClick={this.deselectAll}
              >
                <h6 ><IoMdRemove /></h6>
                <input type="checkbox" hidden={true} checked={allSelected}/>
              </div>
            }
          </td>
          <td>
            <p className={'tableHead'}>Name</p>
          </td>
          <td>
            <p className={'tableHead'}>Last Modified</p>
          </td>
          <td>
            <p className={'tableHead'}>Size</p>
          </td>
        </tr>
      </thead>
      <tbody>
      {
        data.map(info => {
          const { id, starred } = info;
          const isSelected = this.state.selections.indexOf(id) !== -1;
          const isStarred = starred;

          return (
            <TableRow
              key={info.id}
              onMouseOver={() => {
                this.setState({
                  hoveringOver: id
                })
              }}
              onMouseLeave={() => {
                this.setState({
                  hoveringOver: null
                })
              }}
              onCheckbox={async () => {
                let _selections = this.state.selections;

                const containsItem = _selections.includes(id);

                if (containsItem) {
                  _selections.splice(_selections.indexOf(id), 1);
                } else {
                  _selections.push(id);
                }

                await this.updateSelections(_selections);
                this.forceUpdate()
              }}
              onSelect={async () => {
                await this.updateSelections([id]);
              }}
              isStarred={isStarred}
              isSelected={isSelected}
              onView={() => {
                this.props.getObjectDownload({ id });

                const ids = data.map(info => info.id)

                let idIndex = ids.indexOf(id);

                this.props.showPreview && this.props.showPreview({
                  next: () => {
                    const indexToGet = idIndex + 1;

                    if ( (data.length - 1) >= indexToGet && indexToGet > 0 ) {
                      const idToGet = data[indexToGet].id;

                      this.props.getObjectDownload({ id: idToGet });

                      idIndex++;
                    }
                  },
                  back: () => {
                    const indexToGet = idIndex - 1;

                    if ( (data.length - 1) >= indexToGet && indexToGet > 0 ) {
                      const idToGet = data[indexToGet].id;

                      this.props.getObjectDownload({ id: idToGet });

                      idIndex--;
                    }
                  }
                })
              }}
              canPreview={this.props.canPreview}
              hideLasModified={true}
              {...info}
            />
          )
        })
      }
      </tbody>
    </table>
  )

  render() {
    const { data = [] } = this.props;

    const { selections = [] } = this.state;

    const hasData = data.length > 0;

    const oneSelected = selections.length === 1;
    const multipleSelected = selections.length > 1;
    const allSelected = selections.length === data.length;

    return (
      <div style={{ marginLeft: 10, position: 'absolute', bottom: 0, left: 0, right: 0, top: 0 }}>
        <p
          style={{ visibility: selections.length > 0 ? 'visible' : 'hidden', marginBottom: 10, backgroundColor: 'white'}}
        >
          {selections.length} {selections.length < 2 ? 'file': 'files'} selected
        </p>
        <Row
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            top: 40,
            overflow: 'scroll'
          }}
        >
          <Col
            xs={12}
            sm={12}
            md={10}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }}
            >
              <div
              onScroll={this.trackScrolling}
              className={'table-col'}
              >
                {hasData ?
                  this.renderTable({ data, oneSelected, multipleSelected, allSelected })
                  :
                  this.renderNoData()
                }
              </div>
            </div>
          </Col>
          <Col
            className='d-none d-sm-none d-md-block'
            xs={12}
            sm={12}
            md={2}
            style={{
              height: 'fit-content'
            }}
          >
            <RightSidebar
              oneSelected={oneSelected}
              multipleSelected={multipleSelected}
              allSelected={allSelected}
              onDelete={this.onDelete}
              onDownload={this.onDownload}
              {...this.props}
            />
          </Col>
        </Row>
        <div className={`loader-container ${this.props.loading || this.state.loading ? 'loading-show' : 'loading-hide'}`}>
          <div className="loader"></div>
        </div>
      </div>
    );
  }
}

MainView.defaultProps = {
  objects: []
};

const mapStateToProps = (state) => ({
  objects: state.objects,
  type: state.type,
  deletedIds: state.deletedIds,
  preview: state.preview,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ deleteObjects }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(MainView);
